import { Modal } from "flowbite-react";
import restService from "../../../../restService";
import { useContext, useState } from "react";
import CampaignContext from "../../../../contexts/CampaignContext";
import UserContext from "../../../../contexts/UserContext";

export default function UpdateMemberRole({
  show,
  onClose,
  selectedMember,
  setSelectedMember,
  getCampaignMembers,
}) {
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);

  const [updatingMemberRole, setUpdatingMemberRole] = useState(false);

  async function handleUpdateMemberRole() {
    setUpdatingMemberRole(true);
    try {
      const { data } = await restService.Settings.updateMemberRole(
        campaign?.id,
        selectedMember?.email,
        selectedMember?.newRole?.toUpperCase()?.replaceAll("-", "_"),
        user?.accessToken
      );

      getCampaignMembers?.();
      setUpdatingMemberRole(false);
      onClose?.(() => setSelectedMember(null));
    } catch (error) {
      console.log(error);
      setUpdatingMemberRole(false);
    }
  }

  return (
    <Modal
      show={show}
      size="sm"
      placement="center"
      onClose={() => onClose?.(() => setSelectedMember(null))}
    >
      {updatingMemberRole ? (
        <>
          <p className=" transition-all md:p-12 p-5 text-center text-sm rounded ">
            Update {selectedMember?.name}'s role...
          </p>
        </>
      ) : (
        <div className="flex flex-col gap-3 justify-center items-center md:p-12 p-5">
          <h4 className="text-[20px] font-[600] text-[#24211D]">
            Update Member Role
          </h4>{" "}
          <p className="text-center text-sm">
            Are you sure you want to change {selectedMember?.name}'s role to{" "}
            <b>{selectedMember?.newRole}?</b>
          </p>
          <div className="flex gap-3 justify-center items-center mt-2">
            <button
              className="bg-[#3989DD]  hover:bg-[#4572a1] transition-all px-4 py-2 text-sm rounded text-white"
              onClick={() => handleUpdateMemberRole(selectedMember)}
            >
              YES
            </button>
            <button onClick={() => onClose?.(() => setSelectedMember(null))}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}
